import { useState, useLayoutEffect, FC } from 'react';
import ReactDOM from 'react-dom';
import { PortalProps } from './portal.types';

const Portal: FC<PortalProps> = ({ children, container, disablePortal = false }) => {
  const [mountNode, setMountNode] = useState<Element | null>(null);

  useLayoutEffect(() => {
    if (disablePortal) {
      return;
    }

    let resolvedContainer: Element | null = null;
    if (typeof container === 'function') {
      resolvedContainer = container();
    } else if (container) {
      resolvedContainer = container;
    } else {
      resolvedContainer = document.body;
    }

    setMountNode(resolvedContainer || null);
  }, [container, disablePortal]);

  if (disablePortal) {
    return <>{children}</>;
  }

  return mountNode ? ReactDOM.createPortal(children, mountNode) : null;
};

export default Portal;
